import { useAuth } from "./AuthProvider";

const Logout = () => {
  const auth = useAuth();
  return (
            <button onClick={() => auth.logOut()} >
              Logout
            </button>
  );
};

export default Logout;